<template>
  <div class="flex flex-col gap-4">
    <Transition name="fade-left" mode="out-in">
      <div class="flex gap-3 items-center" :key="current">
        <i class="w-8 text-[#2640F9]" v-icon:[items[current].icon]></i>
        <h3 class="w-1 flex-grow font-bold font-nunito text-base" :class="setText(items[current].icon)">
          {{ items[current].text }}
        </h3>
      </div>
    </Transition>
    <div class="flex gap-2">
      <button title="Prev" @click="onPrev" class="w-6 text-primary-0 cursor-pointer">
        <i v-icon:arrow-left></i>
      </button>
      <div class="w-1 flex-grow">
        <div class="swiper" ref="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in items" :key="`swiper-slide-${_uid}-${index}`">
              <div @click="current = index"
                class=" cursor-pointer w-12 h-12 m-auto rounded-full p-2 transition duration-500 hover:grayscale-0 hover:scale-100"
                :class="[{ 'grayscale scale-75': index != current }, setColor(item.icon)]">
                <i v-icon:[item.icon] class="block w-full text-white"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button title="Next" @click="onNext" class="w-6 text-primary-0 cursor-pointer">
        <i v-icon:arrow-right></i>
      </button>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
export default {
  name: 'VMapSlide',
  props: ['items', 'value'],
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      current: 0,
      swiper: null
    }
  },
  mounted() {
    this.swiper = new Swiper(this.$refs['swiper'], {
      slidesPerView: 4.2,
      slidesPerGroup: 1,
      centeredSlides: true,
      centeredSlidesBounds: true,
      allowTouchMove: false,
    });

    this.current = this.items.findIndex(item => item.value == this.value);
  },
  watch: {
    current(a) {
      this.$emit("change", this.items[a].value);
      this.swiper.slideTo(a, 500);
    }
  },
  methods: {
    setColor(icon) {
      switch (icon) {
        case 'icon-gazel':
          return 'bg-[#2640F9]';
        case 'icon-altoque':
          return 'bg-[#FCF1DE]';
        default:
          return 'bg-[#F1F1F6]';

      }
    },
    setText(icon) {
      switch (icon) {
        case 'icon-gazel':
        case 'icon-voltex':
          return 'text-blue-dark-40';
        default:
          return 'text-primary-0';

      }
    },
    onNext() {
      if (this.current < this.items.length - 1) {
        this.current++;
      } else {
        this.current = 0;
      }
    },
    onPrev() {
      if (this.current > 0) {
        this.current--;
      } else {
        this.current = this.items.length - 1;
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>